import _ from 'lodash'
import { LBLoader, LBSkeleton } from '@linearb/buzz'
import DashboardLayout from '../layouts/DashboardLayout'

interface PageSkeletonProps {
  message?: string
}

const PageSkeleton: React.FC<PageSkeletonProps> = ({ message }) => (
  <DashboardLayout>
    {message && (
      <div className='flex items-center justify-center gap-3 pb-6 text-muted-foreground'>
        <LBLoader className='h-5 w-5' />
        <span className='text-sm'>{message}</span>
      </div>
    )}
    <div className='space-y-4'>
      <LBSkeleton className='h-8 w-1/3' />
      <LBSkeleton className='h-4 w-2/3' />
      <div className='space-y-2 pt-4'>
        {_.range(8).map(row => (
          <LBSkeleton key={row} className='h-12 w-full' />
        ))}
      </div>
    </div>
  </DashboardLayout>
)

export default PageSkeleton
